"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAxiosClientError = isAxiosClientError;
exports.createAxiosClient = createAxiosClient;
const axios_1 = __importStar(require("axios"));
const stream_1 = require("stream");
const httpError_1 = require("./httpError");
const CORRELATION_ID = 'X-Correlation-Id';
const CALLER_ID = 'X-Caller-Id';
const TEST_STRATEGY = 'X-Test-Strategy';
const LOCALE = 'Idf-Locale';
function isAxiosClientError(error) {
    if (!error) {
        return false;
    }
    return (error === null || error === void 0 ? void 0 : error.isAxiosError) === true;
}
function createAxiosClient(apiHost, options) {
    var _a;
    const client = axios_1.default.create({
        baseURL: `${apiHost}`,
        timeout: options.timeout,
        headers: {
            Accept: (_a = options.accept) !== null && _a !== void 0 ? _a : 'application/json',
        },
    });
    function accessTokenInterceptor() {
        return __awaiter(this, void 0, void 0, function* () {
            if (options.accessTokenSource !== undefined) {
                const accessToken = yield options.accessTokenSource();
                if (accessToken !== null) {
                    return new axios_1.AxiosHeaders({ Authorization: `Bearer ${accessToken}` });
                }
            }
            return new axios_1.AxiosHeaders();
        });
    }
    function correlationIdInterceptor() {
        return __awaiter(this, void 0, void 0, function* () {
            if (options.correlationIdSource !== undefined) {
                const correlationId = yield options.correlationIdSource();
                if (correlationId !== null) {
                    return new axios_1.AxiosHeaders({ [CORRELATION_ID]: correlationId });
                }
            }
            return new axios_1.AxiosHeaders();
        });
    }
    function callerIdInterceptor() {
        const { callerId } = options;
        if (callerId !== null) {
            return new axios_1.AxiosHeaders({ [CALLER_ID]: callerId });
        }
        return new axios_1.AxiosHeaders();
    }
    function localeSourceInterceptor() {
        const { localeSource } = options;
        if (localeSource) {
            return new axios_1.AxiosHeaders({ [LOCALE]: localeSource() });
        }
        return new axios_1.AxiosHeaders();
    }
    function testStrategyInterceptor() {
        return __awaiter(this, void 0, void 0, function* () {
            const { testStrategySource } = options;
            if (testStrategySource) {
                const testStrategy = yield testStrategySource();
                if (testStrategy) {
                    return new axios_1.AxiosHeaders({ [TEST_STRATEGY]: testStrategy });
                }
            }
            return new axios_1.AxiosHeaders();
        });
    }
    function customHeadersInterceptor() {
        const { customHeaders } = options;
        if (customHeaders) {
            return new axios_1.AxiosHeaders(customHeaders);
        }
        return new axios_1.AxiosHeaders();
    }
    client.interceptors.request.use((config) => __awaiter(this, void 0, void 0, function* () {
        const tokenHeader = yield accessTokenInterceptor();
        const correlationIdHeader = yield correlationIdInterceptor();
        const callerIdHeader = callerIdInterceptor();
        const localeHeader = localeSourceInterceptor();
        const testStrategyHeader = yield testStrategyInterceptor();
        const customHeaders = customHeadersInterceptor();
        const headers = config.headers.concat(tokenHeader, correlationIdHeader, callerIdHeader, localeHeader, testStrategyHeader, customHeaders);
        return Object.assign(Object.assign({}, config), { headers });
    }));
    client.interceptors.response.use(undefined, (error) => {
        var _a, _b;
        if (isAxiosClientError(error) && options.useHttpError) {
            const isNodeStreamAvailable = Boolean(stream_1.Readable);
            const unStreamedData = isNodeStreamAvailable && ((_a = error.response) === null || _a === void 0 ? void 0 : _a.data) instanceof stream_1.Readable
                ? error.response.data.toArray()
                : Promise.resolve((_b = error.response) === null || _b === void 0 ? void 0 : _b.data);
            return unStreamedData.then((data) => {
                throw new httpError_1.HttpError(error, data);
            });
        }
        return Promise.reject(error);
    });
    return client;
}
//# sourceMappingURL=data:application/json;base64,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